// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planoscontas_HistoryResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for history endpoint
 *
 * Returns array of plano (budget template) records for a franchise,
 * ordered by created_at DESC (newest first).
 * Each plano mirrors the `planos_de_contas` row shape.
 *
 * @see Planoscontas_PlanoRow
 */
import type { Planoscontas_PlanoRow } from './Planoscontas_PlanoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Planoscontas_HistoryResponseDados {
planos: Planoscontas_PlanoRow[]
}

export type Planoscontas_HistoryResponse = ApiResponse<Planoscontas_HistoryResponseDados>;

registerResponseContract('Planoscontas_HistoryResponse', {
  planos: {
    type: 'array',
    required: true,
    items: {
      id:          { type: 'number',  required: false },
      franquia_id: { type: 'number',  required: false },
      status:      { type: 'string',  required: false },
      nome:        { type: 'string',  required: false },
      created_at:  { type: 'string',  required: false },
      updated_at:  { type: 'string',  required: false },
      deleted_at:  { type: 'string',  required: false },
    },
  },
})
